<div
  id="main"
  [ngClass]="folded ? 'main-folded' : 'main-unfolded'"
  class="overflow-hidden">
  <div>
    <app-global-spinner></app-global-spinner>
    <div class="mcresidus-header relative z-49 flex items-center shadow print:hidden" style="height: 54px;">
      <div
        class="logo-area relative h-full shrink-0 overflow-hidden transition-[width] duration-500 ease-in-out"
        [style.width.px]="useLargeLogo ? 211 : 54">
        <img
          alt="Logo Residus"
          class="absolute left-0 top-0 h-full w-auto object-contain object-left transition-[clip-path] duration-[250ms] ease-in-out"
          [style.clip-path]="useLargeLogo ? 'inset(0 100% 0 0)' : 'inset(0 0 0 0)'"
          [style.transition-delay]="useLargeLogo ? '0ms' : '250ms'"
          src="images/logo/Logo_small.png" />
        <img
          alt="Logo Residus"
          class="absolute left-0 top-0 h-full w-auto object-contain object-left transition-[clip-path] duration-[250ms] ease-in-out"
          [style.clip-path]="useLargeLogo ? 'inset(0 0 0 0)' : 'inset(0 100% 0 0)'"
          [style.transition-delay]="useLargeLogo ? '250ms' : '0ms'"
          src="images/logo/Logo_large_white.png" />
      </div>
      <div class="text-white ml-auto flex items-center space-x-0.5 pr-2 sm:space-x-2">
        <user></user>
      </div>
    </div>

    <div class="flex flex-row w-full min-h-[100vh]">
      @if (this._layoutService.getShowMenu()) {
        <fuse-vertical-navigation
          class="light bg-white print:hidden"
          [style.flex-basis]="menuOpened ? '20%' : '54px'"
          [style.flex-grow]="0"
          [style.flex-shrink]="0"
          [modeInput]="'side'"
          [nameInput]="'mainNavigation'"
          [navigation]="navigation"
          [appearanceInput]="'default'"
          [openedInput]="!isScreenSmall">
          <!-- Navigation header hook -->
          <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <button
              class="m-2"
              (click)="toggleNavigation('mainNavigation')"
              mat-icon-button>
              <mat-icon
                class="text-black"
                [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
          </ng-container>
        </fuse-vertical-navigation>
      }
      <content class="basis-4/5"></content>
    </div>
  </div>
</div>
